/**
 * Return a content ID for an organization.
 */
export function getOrganizationRootContentId(organizationId: string): string {
    return `org:${organizationId}`;
}
